import StudyItem from "../../components/blogs/StudyItem";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

export default function StudiesDetails({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <PageHeader
        HeaderTitle="Current Studies"
        PageTite="Current Studies"
        Parent="Current Studies"
      />
      <StudyItem />
      <Footer information={information} />
    </Layout>
  );
}
